import zIndex from "@mui/material/styles/zIndex";
import React from "react";

const Loader = () => {
  const loaderContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1000,
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    zIndex:10000
  };

  const loaderWrapperStyle = {
    textAlign: 'center',
  };

  const loaderStyle = {
    display: 'inline-block',
    width: '80px',
    height: '80px',
    position: 'relative',
  };

  const loaderDivStyle = {
    position: 'absolute',
    border: '4px solid #3498db',
    opacity: 1,
    borderRadius: '50%',
    animation: 'custom-loader-animation 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite',
  };

  const textStyle = {
    marginTop: '20px',
    fontSize: '18px',
    color: '#2c3e50',
    fontFamily: 'Arial, sans-serif',
  };

  return (
    <div style={loaderContainerStyle}>
      <div style={loaderWrapperStyle}>
        <div style={loaderStyle}>
          <div style={{ ...loaderDivStyle, animationDelay: '0s' }}></div>
          <div style={{ ...loaderDivStyle, animationDelay: '-0.5s' }}></div>
          <div style={{ ...loaderDivStyle, animationDelay: '-1s' }}></div>
          <div style={{ ...loaderDivStyle, animationDelay: '-1.5s' }}></div>
        </div>
        <p style={textStyle}>Please wait... while we are processing</p>
      </div>
      {/* Keyframes */}
      <style>
        {`
          @keyframes custom-loader-animation {
            0% {
              top: 36px;
              left: 36px;
              width: 0;
              height: 0;
              opacity: 1;
            }
            100% {
              top: 0;
              left: 0;
              width: 72px;
              height: 72px;
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
